if (!customElements.get('masi-home-video')) {
  customElements.define('masi-home-video', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const video = this.querySelector('video');
      const play = this.querySelector('.mh-play');
      const fallback = this.querySelector('.mh-video-fallback');
      if (!video || !play) return;
      const restore = () => { play.hidden = false; };
      const failed = () => { restore(); fallback.hidden = false; };
      play.hidden = false;
      play.addEventListener('click', () => {
        play.hidden = true;
        fallback.hidden = true;
        video.controls = true;
        video.play().then(() => video.focus({ preventScroll: true })).catch(failed);
      }, { signal });
      video.addEventListener('ended', restore, { signal });
      video.addEventListener('error', failed, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
